'use client';

import classNames from 'classnames';
import NextLink from 'next/link';
import { FC, useCallback, useMemo } from 'react';

import { usePathname } from '../../../i18n/routing';
import { ArrowIcon } from '../../icons';

import { MenuListItem } from './Sidebar';
import styles from './Sidebar.module.scss';

type MenuItemContentProps = {
  item: MenuListItem;
};

export const MenuItemContent: FC<MenuItemContentProps> = (props) => {
  const {
    item: { target, icon, title, onClick },
  } = props;

  const pathname = usePathname();

  const handleClick = useCallback(() => {
    onClick?.();
  }, [onClick]);

  const isActive = useMemo(() => {
    if (pathname.substring(1).includes('/') && target) {
      return pathname.split('/')[1] === target.split('/')[1];
    }

    return pathname === target;
  }, [pathname, target]);

  const content = useMemo(() => {
    return (
      <>
        {isActive && (
          <span className={styles.arrowIcon}>
            <ArrowIcon />
          </span>
        )}

        {icon}

        <span>{title}</span>
      </>
    );
  }, [icon, isActive, title]);

  const rootProps = {
    className: classNames(styles.menuItemContent, { [styles.activeLink]: isActive }),
    children: content,
    onClick: handleClick,
  };

  if (target) {
    return <NextLink href={target} {...rootProps} />;
  }

  return <span {...rootProps} />;
};
